import * as React from 'react';
import { Loader, Alert } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { useLink, useLocation } from '@grandvisionhq/frk-routing';
import { useIntl, useDispatch, useSelector, uninitState, statusSuccess, statusUninit, statusLoading, statusFailed, statusWarning } from '@grandvisionhq/state';
import { fetchList } from '../actions.js';
import { getSubscriptionList } from '../selectors.js';
import NoSubscriptions from './NoSubscriptions/NoSubscriptions.js';

/**
 * This component never renders a list of subscriptions. The business rule is that
 * a user can only have a single subscription, so once the "list" of subscriptions is
 * loader we're forwarding the user to the detail page of that subscription.
 */ const SubscriptionList = ()=>{
    var ref;
    const intl = useIntl();
    const dispatch = useDispatch();
    var ref1;
    const list = (ref1 = useSelector(getSubscriptionList)) !== null && ref1 !== void 0 ? ref1 : uninitState();
    var ref2;
    // Need the subscription ID to create a URL.
    const subscriptionId = statusSuccess(list) ? (ref2 = (ref = list.result[0]) === null || ref === void 0 ? void 0 : ref.id) !== null && ref2 !== void 0 ? ref2 : '' : '';
    const linkProps = useLink({
        route: 'me.subscriptions.detail',
        params: {
            subscriptionId
        }
    });
    const subscriptionDetailPageUrl = linkProps === null || linkProps === void 0 ? void 0 : linkProps.href;
    const location = useLocation();
    React.useEffect(()=>{
        dispatch(fetchList());
    /* Usual method to call a data fetching function only on mount. */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (statusUninit(list) || statusLoading(list)) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    if (statusFailed(list) || statusWarning(list)) {
        return /*#__PURE__*/ React.createElement(Alert, {
            type: "error",
            title: intl.getLabel('account.subscriptions.errors.general')
        });
    }
    if (statusSuccess(list)) {
        /**
     * If the request is successful but returns no subscriptions, we want to show a specific page.
     */ if (list.result.length < 1) {
            return /*#__PURE__*/ React.createElement("div", {
                className: "subscription-list"
            }, /*#__PURE__*/ React.createElement(Heading, {
                variant: "small",
                component: "h1",
                className: "subscription-list__title"
            }, intl.getLabel('account.subscription.list.title')), /*#__PURE__*/ React.createElement(NoSubscriptions, null));
        }
        /**
     * Forward the user to the detail page of their subscription. Replace
     * the route, because there's no need for them to return to the list
     * page (which will only show a loader and redirect them to the detail
     * page again).
     */ const { hash  } = window.location;
        const url = new URL(`${origin}${subscriptionDetailPageUrl}${hash}`);
        location.replace(url);
    }
    return null;
};
var SubscriptionList$1 = SubscriptionList;

export { SubscriptionList, SubscriptionList$1 as default };
//# sourceMappingURL=SubscriptionList.js.map
